import React from 'react'
import { Translate } from 'react-localize-redux'
import { makeStyles } from '@material-ui/core/styles'
import { Paper, Button, Typography, Toolbar } from '@material-ui/core'
import { SubLink } from 'containers'
import { Carousel } from 'components'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import CarouselItem from 'components/material/CarouselItem'
import PropTypes from 'prop-types'
import ArticleCard from 'routes/ArticlesDashboard/components/ArticleCard'
import { ARTICLES_DASHBOARD_ROUTE } from 'constants/routes'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(0, 3, 3),
  },
  carouselItem: {
    border: '1px solid #e8e8e8',
    '& .MuiCardContent-root': {
      padding: theme.spacing(2, 2, 0),
    },
  },
  toolbar: {
    minHeight: 54,
  },
  descriptionCell: {
    height: 50,
  },
  media: {
    height: 140,
    backgroundPosition: 'top',
  },
  title: {
    flex: '1 1 0',
  },
  cardActions: {
    paddingLeft: theme.spacing(2),
  },
  fab: {
    position: 'absolute',
    top: theme.spacing(-3),
    right: theme.spacing(2),
  },
}))

const ArticlesWidget = ({
  articles,
  handleFavoriteArticle,
  providerName,
  providerUuid,
}) => {
  const classes = useStyles()

  return (
    <Paper className={classes.root}>
      <Toolbar disableGutters={false} className={classes.toolbar}>
        <Typography variant="h4" component="h4" className={classes.title}>
          {providerName} <Translate id="home.articles" />
        </Typography>
        <Button
          color="primary"
          component={SubLink}
          to={ARTICLES_DASHBOARD_ROUTE}
          endIcon={<ChevronRightIcon />}
        >
          <Translate id="home.read-more" />
        </Button>
      </Toolbar>
      <Carousel>
        {articles.map((article) => (
          <CarouselItem key={article.uuid}>
            <ArticleCard
              article={article}
              onFavoriteToggle={() =>
                handleFavoriteArticle(article, providerUuid)
              }
              showArticleActions={false}
            />
          </CarouselItem>
        ))}
      </Carousel>
    </Paper>
  )
}

ArticlesWidget.propTypes = {
  articles: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      favorite: PropTypes.bool.isRequired,
      content: PropTypes.shape({
        reading_time: PropTypes.number,
      }),
      relationships: PropTypes.shape({
        thumbnail: PropTypes.shape({
          full_url: PropTypes.string,
        }),
      }),
    })
  ).isRequired,
  providerName: PropTypes.string.isRequired,
  handleFavoriteArticle: PropTypes.func.isRequired,
  providerUuid: PropTypes.string.isRequired,
}

export default ArticlesWidget
